import type { QueryClient } from '@tanstack/react-query'
import { lookupKeys } from '@/shared/queries/lookupKeys'

export type LookupEntity =
  | 'client'
  | 'site'
  | 'employee'
  | 'department'
  | 'employmentCategory'
  | 'shiftCategory'

const LOOKUP_ROOTS: Record<LookupEntity, readonly unknown[]> = {
  client: lookupKeys.client.root,
  site: lookupKeys.site.root,
  employee: lookupKeys.employee.root,
  department: lookupKeys.department.root,
  employmentCategory: lookupKeys.employmentCategory.root,
  shiftCategory: lookupKeys.shiftCategory.root,
}

const LOOKUP_DEPENDENTS: Partial<Record<LookupEntity, LookupEntity[]>> = {
  client: ['site'],
}

export const invalidateLookups = (
  queryClient: QueryClient,
  ...entities: LookupEntity[]
): void => {
  const targets = new Set<LookupEntity>()
  for (const entity of entities) {
    targets.add(entity)
    for (const dependent of LOOKUP_DEPENDENTS[entity] ?? []) {
      targets.add(dependent)
    }
  }
  for (const target of targets) {
    queryClient.invalidateQueries({ queryKey: LOOKUP_ROOTS[target] })
  }
}
